import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges} from '@angular/core';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { take } from 'rxjs/operators';
import {
  DataEditFieldSummaryResponse,
  DataEditSummaryResponse,
  DataTransportSummaryResponse
} from '@features/data-tracing/models/data-edit-summary.model';
import {Subject} from 'rxjs';
import {Api} from "@shared/constants/common-field.constants";
import {DataTracingService} from "@features/data-tracing/services/data-tracing.service";

@Component({
    standalone: false,
    selector: 'app-data-sources',
  templateUrl: './data-sources.component.html',
  styleUrls: ['./data-sources.component.scss']
})
export class DataSourcesComponent implements OnInit, OnDestroy , OnChanges{
  @Input() public dataEditSummaryId: string;
  @Input() public sourceType: string;
  @Input() public invalidate: boolean;
  @Output() public dataSourcesEvent: EventEmitter<any> = new EventEmitter<any>();

  dataEditSummary: DataEditSummaryResponse = null;
  isDataReceived: boolean = false;

  unSubscribe$ = new Subject<void>();

  constructor(
    private dataTracingService: DataTracingService,
    private platformQueryService: PlatformQueryService) {}

  ngOnInit(): void {
    console.log('DataSourcesComponent onInit', this.dataEditSummaryId, this.sourceType, this.invalidate);
    this.getDataEditSummary();
  }

  getCategoryIconByCategoryType(categoryType: string) {
    switch (categoryType) {
      case 'BlankFields':
        return 'blank-icon';
      case 'EATWorkflow':
        return 'eat-workflow-icon';
      case 'OrbitaxConnect':
        return 'contact-icon';
      case 'ImportExcel':
        return 'upload-icon';
      case 'DirectEdit':
        return 'user-input-icon';
      case 'Workbook':
        return 'other-source-icon';
      case 'Qnr':
        return 'other-source-icon';
      default:
        return 'other-source-icon';
    }
  }

  private getCategoryTitle(title: string) {
    let processedTitle = title;
    switch (title) {
      case 'DirectEdit':
        processedTitle = 'User Input';
        break;
      case 'Qnr':
        processedTitle = 'QNR';
        break;
      case 'ImportExcel':
        processedTitle = 'Upload Template';
        break;
      case 'ItpFields':
        processedTitle = 'Itp Fields';
        break;
      case 'OrbitaxConnect':
        processedTitle = 'Orbitax Connect';
        break;
      default:
        break;
    }
    return processedTitle;
  }

  private processDataEditSummary() {
    for (const summaryByType of this.dataEditSummary.summariesByType) {
      summaryByType.categoryTitle = this.getCategoryTitle(summaryByType.categoryType);
      summaryByType.categoryIconClass = this.getCategoryIconByCategoryType(summaryByType.categoryType);
      for (const dataTransportSummary of summaryByType.dataTransportSummaries) {
        for (const fieldSummary of dataTransportSummary.dataEditFieldSummaryResponses) {
          fieldSummary.toolTip = this.makeToolTip(fieldSummary);
        }
      }
    }
  }

  private makeToolTip(fieldSummary: DataEditFieldSummaryResponse): string {
    fieldSummary.toolTip = '';
    if (fieldSummary.sourceField) {
      fieldSummary.toolTip = 'Source Field : ' + fieldSummary.sourceField;
    }
    if (fieldSummary.reference) {
      fieldSummary.toolTip = fieldSummary.toolTip + '<br>' + 'Reference : ' + fieldSummary.reference;
    }
    if (fieldSummary.toolTip === '') {
      fieldSummary.toolTip = fieldSummary.title;
    }
    return fieldSummary.toolTip;
  }

  private getDataEditSummary() {
    const query = new PlatformQuery();
    query.api = Api.Collaboration;
    query.name = 'GetDataEditSummaryByIdQuery';
    query.projectId = '[PROJECT_ID]';
    query.fieldValues = {
      'DataEditSummaryId': this.dataEditSummaryId,
      'SourceType': this.sourceType
    };
    this.tryAddScenarioInformationToQuery(query);
    this.isDataReceived = false;
    this.platformQueryService.executeQuery(query).pipe(take(1)).subscribe(response => {
      console.log('data edit summary response:', response);
      this.dataEditSummary = response.fieldValues['DataEditSummaryResponse'];
      this.isDataReceived = true;
      if (!this.dataEditSummary) {
        return;
      }
      this.processDataEditSummary();
    });
  }

  private tryAddScenarioInformationToQuery(query: PlatformQuery) : boolean {
    if (this.platformQueryService.platformLinkModel && this.platformQueryService.platformLinkModel.fieldValues['ScenarioId']) {
      query.setValue("ScenarioId", this.platformQueryService.platformLinkModel.fieldValues['ScenarioId']);
      query.setValue("CountryCode", this.platformQueryService.platformLinkModel.fieldValues['CountryCode']);
      query.setValue("ScenarioType", this.platformQueryService.platformLinkModel.fieldValues['ScenarioType']);
      return true;
    }
    return false;
  }

  onOpenSource($event: any, summary: DataTransportSummaryResponse) {
    $event.stopPropagation();
    this.dataTracingService.navigateToSource(summary);
  }

  ngOnDestroy(): void {
    this.unSubscribe$.next();
    this.unSubscribe$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('DataSourcesComponent Changes', changes);
    if (changes['invalidate']?.isFirstChange()) {
      return;
    }
    if (changes['invalidate']?.currentValue) {
      this.getDataEditSummary();
      this.invalidate = false;
      return;
    }
    this.getDataEditSummary();
  }
}
